<template>
  <v-dialog
    v-model="dialog"
    width="600"
    scrollable
  >
    <template v-slot:activator="{ on, attrs}">
      <v-btn
        small
        v-bind="attrs"
        v-on="on"
        @click="$router.push({name: 'CollaboratorFinalUserNotificationSee'})"
      >
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar>
        <v-toolbar-title>
          {{ $route.meta.nameDrawer }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text
        class="pa-4 grey lighten-1"
        style="min-height: 300px;"
      >
        <v-card class="white black--text pa-4" style="min-height: 300px;">
          <div v-html="message" style="height: auto"></div>
        </v-card>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "see-notification",
  props: {
    notification: {
      type: Object
    }
  },
  data: () => ({
    dialog: false,
    message: "",
  }),

  mounted() {
    this.message = this.convertLinksToClickable(this.notification.description)
  },

  methods: {
    closeDialog() {
      this.dialog = false;
      this.$router.go(-1);
    },

    convertLinksToClickable(text) {
      // para verificar se o link tem https:// no início
      const httpsRegex = /^https?:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/i; //eslint-disable-line

      // para verificar se existe algum link no texto
      const urlRegex = /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?/g; //eslint-disable-line

      // Tratamento para envolver o link em tags <a></a>
      const clickableText = text.replace(urlRegex, (match) => {
        // se o link não tiver https:// no início,
        // insere, isso evita bug no redirecionamento
        if (!httpsRegex.test(match)) {
          return `<a href="https://${match}" target="_blank">${match}</a>`;
        }

        return `<a href="${match}" target="_blank">${match}</a>`;
      });

      return clickableText;
    }


  }
}
</script>